import React from "react"
import shallowCompare from "react-addons-shallow-compare"
import _ from "lodash/function"
import { getAccountSettings } from "../../scripts/accountSettings"
import { injectIntl } from "react-intl"
import settingsMessages from "../../messages/settings"

class ImgSrcSet extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      src: props.src,
      hasError: false
    }

    //Throttle calls to this function as will call from window resize
    this._setSrc = _.throttle(this._setSrc, 800)
  }

  _setSrc = () => {
    const accountSettings = getAccountSettings(
      this.props.intl.formatMessage(settingsMessages.authenticAccountId)
    )
    if (this._imgEl) {
      // Pull source from currentSrc where this is supported by browser and update our main image
      let src = this._imgEl.currentSrc
        ? this._imgEl.currentSrc
        : this._imgEl.src

      if (this.state.hasError) {
        src = accountSettings.defaultImage
      }

      this.setState({ src })
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState)
  }

  componentDidMount() {
    // On window resize we are going to look for a new src from the srcSet
    this._windowListener = window.addEventListener("resize", this._setSrc)

    setTimeout(() => this._setSrc(), 300)
  }

  componentDidUpdate() {
    this._setSrc()
  }

  componentWillReceiveProps(props) {
    this.setState({ src: props.src }, () => {
      this._setSrc()
    })
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._setSrc)
  }

  onError = () => {
    if (!this.state.hasError) {
      this.setState({
        hasError: true
      })
    }
  }

  render() {
    const { srcSet, sizes, imgAlt, src, className } = this.props
    const srcSetSrc = this.state.src

    return (
      <div
        className={`image-srcset-bg ${className || ""}`}
        style={srcSetSrc && { backgroundImage: "url('" + srcSetSrc + "')" }}
      >
        <img
          alt={imgAlt}
          sizes={sizes}
          srcSet={srcSet.join(", ")}
          src={src}
          ref={el => {
            this._imgEl = el
            this._setSrc()
          }}
          onError={this.onError}
        />
      </div>
    )
  }
}

export default injectIntl(ImgSrcSet)



// WEBPACK FOOTER //
// ./webapp/components/elements/ImgSrcSet.js